import { twoButtonModalStyles } from "@insite/content-library/Components/TwoButtonModal";
import { actionStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsActions";
import { productListLineStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsProductListLine";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

twoButtonModalStyles.submitButton = {
    variant: "primary",
};
twoButtonModalStyles.cancelButton = {
    variant: "secondary",
    css: css`
        margin-right: 10px;
        :hover {
            opacity: 0.3;
            border-color: ${getColor("text.main")} !important;
        }
    `,
};
